module.exports = __webpack_public_path__ + "static/movie-ea5e9451a53ea85c26a0277943f692b5.png";